module.exports = __webpack_public_path__ + "static/img/1.a0d8e25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/1.png
// module id = tDaY
// module chunks = 0